import _toConsumableArray from "/tmp/builds/83b4778c-6135-4455-a9f0-1945141a3a9d-develop-nodeV18-18/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/tmp/builds/83b4778c-6135-4455-a9f0-1945141a3a9d-develop-nodeV18-18/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/tmp/builds/83b4778c-6135-4455-a9f0-1945141a3a9d-develop-nodeV18-18/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _slicedToArray from "/tmp/builds/83b4778c-6135-4455-a9f0-1945141a3a9d-develop-nodeV18-18/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/tmp/builds/83b4778c-6135-4455-a9f0-1945141a3a9d-develop-nodeV18-18/node_modules/@babel/runtime/regenerator/index.js";
import "core-js/modules/esnext.string.replace-all.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var K = Object.defineProperty,
    Y = Object.defineProperties;
var V = Object.getOwnPropertyDescriptors;
var y = Object.getOwnPropertySymbols;
var P = Object.prototype.hasOwnProperty,
    D = Object.prototype.propertyIsEnumerable;

var I = function I(t, e, r) {
  return e in t ? K(t, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : t[e] = r;
},
    d = function d(t, e) {
  for (var r in e || (e = {})) {
    P.call(e, r) && I(t, r, e[r]);
  }

  if (y) {
    var _iterator = _createForOfIteratorHelper(y(e)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var r = _step.value;
        D.call(e, r) && I(t, r, e[r]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return t;
},
    O = function O(t, e) {
  return Y(t, V(e));
};

var M = function M(t, e) {
  var r = {};

  for (var n in t) {
    P.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
  }

  if (t != null && y) {
    var _iterator2 = _createForOfIteratorHelper(y(t)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var n = _step2.value;
        e.indexOf(n) < 0 && D.call(t, n) && (r[n] = t[n]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return r;
};

var l = function l(t, e, r) {
  return I(t, typeof e != "symbol" ? e + "" : e, r), r;
};

var x = function x(t, e, r) {
  return new Promise(function (n, s) {
    var a = function a(c) {
      try {
        o(r.next(c));
      } catch (i) {
        s(i);
      }
    },
        u = function u(c) {
      try {
        o(r.throw(c));
      } catch (i) {
        s(i);
      }
    },
        o = function o(c) {
      return c.done ? n(c.value) : Promise.resolve(c.value).then(a, u);
    };

    o((r = r.apply(t, e)).next());
  });
};

var L = "hCaptcha-script",
    b = "hCaptchaOnLoad",
    _ = "script-error";
var g = "@hCaptcha/loader";

function U(t) {
  return Object.entries(t).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        e = _ref2[1];

    return e || e === !1;
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        e = _ref4[0],
        r = _ref4[1];

    return "".concat(encodeURIComponent(e), "=").concat(encodeURIComponent(String(r)));
  }).join("&");
}

function R(t) {
  var e = t && t.ownerDocument || document,
      r = e.defaultView || e.parentWindow || window;
  return {
    document: e,
    window: r
  };
}

function S(t) {
  return t || document.head;
}

function F(t) {
  var e;
  t.setTag("source", g), t.setTag("url", document.URL), t.setContext("os", {
    UA: navigator.userAgent
  }), t.setContext("browser", d({}, z())), t.setContext("device", O(d({}, J()), {
    screen_width_pixels: screen.width,
    screen_height_pixels: screen.height,
    language: navigator.language,
    orientation: ((e = screen.orientation) == null ? void 0 : e.type) || "Unknown",
    processor_count: navigator.hardwareConcurrency,
    platform: navigator.platform
  }));
}

function z() {
  var n, s, a, u, o, c;
  var t = navigator.userAgent,
      e,
      r;
  return t.indexOf("Firefox") !== -1 ? (e = "Firefox", r = (n = t.match(/Firefox\/([\d.]+)/)) == null ? void 0 : n[1]) : t.indexOf("Edg") !== -1 ? (e = "Microsoft Edge", r = (s = t.match(/Edg\/([\d.]+)/)) == null ? void 0 : s[1]) : t.indexOf("Chrome") !== -1 && t.indexOf("Safari") !== -1 ? (e = "Chrome", r = (a = t.match(/Chrome\/([\d.]+)/)) == null ? void 0 : a[1]) : t.indexOf("Safari") !== -1 && t.indexOf("Chrome") === -1 ? (e = "Safari", r = (u = t.match(/Version\/([\d.]+)/)) == null ? void 0 : u[1]) : t.indexOf("Opera") !== -1 || t.indexOf("OPR") !== -1 ? (e = "Opera", r = (o = t.match(/(Opera|OPR)\/([\d.]+)/)) == null ? void 0 : o[2]) : t.indexOf("MSIE") !== -1 || t.indexOf("Trident") !== -1 ? (e = "Internet Explorer", r = (c = t.match(/(MSIE |rv:)([\d.]+)/)) == null ? void 0 : c[2]) : (e = "Unknown", r = "Unknown"), {
    name: e,
    version: r
  };
}

function J() {
  var t = navigator.userAgent,
      e;
  t.indexOf("Win") !== -1 ? e = "Windows" : t.indexOf("Mac") !== -1 ? e = "Mac" : t.indexOf("Linux") !== -1 ? e = "Linux" : t.indexOf("Android") !== -1 ? e = "Android" : t.indexOf("like Mac") !== -1 || t.indexOf("iPhone") !== -1 || t.indexOf("iPad") !== -1 ? e = "iOS" : e = "Unknown";
  var r;
  return /Mobile|iPhone|iPod|Android/i.test(t) ? r = "Mobile" : /Tablet|iPad/i.test(t) ? r = "Tablet" : r = "Desktop", {
    model: e,
    family: e,
    device: r
  };
}

var Q = /*#__PURE__*/function () {
  function B(e) {
    _classCallCheck(this, B);

    l(this, "_parent");
    l(this, "breadcrumbs", []);
    l(this, "context", {});
    l(this, "extra", {});
    l(this, "tags", {});
    l(this, "request");
    l(this, "user");
    this._parent = e;
  }

  _createClass(B, [{
    key: "parent",
    get: function get() {
      return this._parent;
    }
  }, {
    key: "child",
    value: function child() {
      return new B(this);
    }
  }, {
    key: "setRequest",
    value: function setRequest(e) {
      return this.request = e, this;
    }
  }, {
    key: "removeRequest",
    value: function removeRequest() {
      return this.request = void 0, this;
    }
  }, {
    key: "addBreadcrumb",
    value: function addBreadcrumb(e) {
      return typeof e.timestamp > "u" && (e.timestamp = new Date().toISOString()), this.breadcrumbs.push(e), this;
    }
  }, {
    key: "setExtra",
    value: function setExtra(e, r) {
      return this.extra[e] = r, this;
    }
  }, {
    key: "removeExtra",
    value: function removeExtra(e) {
      return delete this.extra[e], this;
    }
  }, {
    key: "setContext",
    value: function setContext(e, r) {
      return typeof r.type > "u" && (r.type = e), this.context[e] = r, this;
    }
  }, {
    key: "removeContext",
    value: function removeContext(e) {
      return delete this.context[e], this;
    }
  }, {
    key: "setTags",
    value: function setTags(e) {
      return this.tags = d(d({}, this.tags), e), this;
    }
  }, {
    key: "setTag",
    value: function setTag(e, r) {
      return this.tags[e] = r, this;
    }
  }, {
    key: "removeTag",
    value: function removeTag(e) {
      return delete this.tags[e], this;
    }
  }, {
    key: "setUser",
    value: function setUser(e) {
      return this.user = e, this;
    }
  }, {
    key: "removeUser",
    value: function removeUser() {
      return this.user = void 0, this;
    }
  }, {
    key: "toBody",
    value: function toBody() {
      var e = [],
          r = this;

      for (; r;) {
        e.push(r), r = r.parent;
      }

      return e.reverse().reduce(function (n, s) {
        var a;
        return n.breadcrumbs = [].concat(_toConsumableArray((a = n.breadcrumbs) != null ? a : []), _toConsumableArray(s.breadcrumbs)), n.extra = d(d({}, n.extra), s.extra), n.contexts = d(d({}, n.contexts), s.context), n.tags = d(d({}, n.tags), s.tags), s.user && (n.user = s.user), s.request && (n.request = s.request), n;
      }, {
        breadcrumbs: [],
        extra: {},
        contexts: {},
        tags: {},
        request: void 0,
        user: void 0
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      this.breadcrumbs = [], this.context = {}, this.tags = {}, this.user = void 0;
    }
  }]);

  return B;
}(),
    Z = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
    ee = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i,
    te = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
    re = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/,
    N = "?",
    k = "An unknown error occurred",
    ne = "0.0.4";

function se(t) {
  for (var e = 0; e < t.length; e++) {
    t[e] = Math.floor(Math.random() * 256);
  }

  return t;
}

function p(t) {
  return (t + 256).toString(16).substring(1);
}

function oe() {
  var t = se(new Array(16));
  return t[6] = t[6] & 15 | 64, t[8] = t[8] & 63 | 128, p(t[0]) + p(t[1]) + p(t[2]) + p(t[3]) + "-" + p(t[4]) + p(t[5]) + "-" + p(t[6]) + p(t[7]) + "-" + p(t[8]) + p(t[9]) + "-" + p(t[10]) + p(t[11]) + p(t[12]) + p(t[13]) + p(t[14]) + p(t[15]);
}

var ie = [[Z, "chrome"], [te, "winjs"], [ee, "gecko"]];

function ae(t) {
  var n, s, a, u;
  if (!t.stack) return null;
  var e = [],
      r = (a = (s = (n = t.stack).split) == null ? void 0 : s.call(n, "\n")) != null ? a : [];

  for (var o = 0; o < r.length; ++o) {
    var c = null,
        i = null,
        f = null;

    var _iterator3 = _createForOfIteratorHelper(ie),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _step3$value = _slicedToArray(_step3.value, 2),
            v = _step3$value[0],
            w = _step3$value[1];

        if (i = v.exec(r[o]), i) {
          f = w;
          break;
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    if (!(!i || !f)) {
      if (f === "chrome") c = {
        filename: (u = i[2]) != null && u.startsWith("address at ") ? i[2].substring(11) : i[2],
        function: i[1] || N,
        lineno: i[3] ? +i[3] : null,
        colno: i[4] ? +i[4] : null
      };else if (f === "winjs") c = {
        filename: i[2],
        function: i[1] || N,
        lineno: +i[3],
        colno: i[4] ? +i[4] : null
      };else if (f === "gecko") o === 0 && !i[5] && t.columnNumber !== void 0 && e.length > 0 && (e[0].column = t.columnNumber + 1), c = {
        filename: i[3],
        function: i[1] || N,
        lineno: i[4] ? +i[4] : null,
        colno: i[5] ? +i[5] : null
      };else continue;
      !c.function && c.lineno && (c.function = N), e.push(c);
    }
  }

  return e.length ? e.reverse() : null;
}

function ce(t) {
  var e = ae(t);
  return {
    type: t.name,
    value: t.message,
    stacktrace: {
      frames: e != null ? e : []
    }
  };
}

function ue(t) {
  var e = re.exec(t),
      r = e ? e.slice(1) : [];
  if (r.length !== 6) throw new Error("Invalid DSN");
  var n = r[5].split("/"),
      s = n.slice(0, -1).join("/");
  return r[0] + "://" + r[3] + (r[4] ? ":" + r[4] : "") + (s ? "/" + s : "") + "/api/" + n.pop() + "/envelope/?sentry_version=7&sentry_key=" + r[1] + (r[2] ? "&sentry_secret=" + r[2] : "");
}

function le(t, e, r) {
  var s, a;
  var n = d({
    event_id: oe().replaceAll("-", ""),
    platform: "javascript",
    sdk: {
      name: "@hcaptcha/sentry",
      version: ne
    },
    environment: e,
    release: r,
    timestamp: Date.now() / 1e3
  }, t.scope.toBody());

  if (t.type === "exception") {
    n.message = (a = (s = t.error) == null ? void 0 : s.message) != null ? a : "Unknown error", n.fingerprint = [n.message];
    var u = [],
        o = t.error;

    for (var c = 0; c < 5 && o && (u.push(ce(o)), !(!o.cause || !(o.cause instanceof Error))); c++) {
      o = o.cause;
    }

    n.exception = {
      values: u.reverse()
    };
  }

  return t.type === "message" && (n.message = t.message, n.level = t.level), n;
}

function de(t) {
  if (t instanceof Error) return t;
  if (typeof t == "string") return new Error(t);

  if (typeof t == "object" && t !== null && !Array.isArray(t)) {
    var r = t,
        n = r.message,
        s = M(r, ["message"]),
        a = new Error(typeof n == "string" ? n : k);
    return Object.assign(a, s);
  }

  var e = new Error(k);
  return Object.assign(e, {
    cause: t
  });
}

function pe(t, e, r) {
  return x(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var n, s, a, c, u, o;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (!(typeof fetch < "u" && typeof AbortSignal < "u")) {
              _context.next = 10;
              break;
            }

            if (r) {
              c = new AbortController();
              a = c.signal, setTimeout(function () {
                return c.abort();
              }, r);
            }

            _context.next = 5;
            return fetch(t, O(d({}, e), {
              signal: a
            }));

          case 5:
            u = _context.sent;
            _context.next = 8;
            return u.text();

          case 8:
            o = _context.sent;
            return _context.abrupt("return", {
              status: u.status,
              body: o
            });

          case 10:
            _context.next = 12;
            return new Promise(function (a, u) {
              var c, i;
              var o = new XMLHttpRequest();
              if (o.open((c = e == null ? void 0 : e.method) != null ? c : "GET", t), o.onload = function () {
                return a({
                  status: o.status,
                  body: o.responseText
                });
              }, o.onerror = function () {
                return u(new Error("XHR Network Error"));
              }, e == null ? void 0 : e.headers) for (var _i = 0, _Object$entries = Object.entries(e.headers); _i < _Object$entries.length; _i++) {
                var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
                    f = _Object$entries$_i[0],
                    v = _Object$entries$_i[1];

                o.setRequestHeader(f, v);
              }

              if (r) {
                var _f = setTimeout(function () {
                  o.abort(), u(new Error("Request timed out"));
                }, r);

                o.onloadend = function () {
                  clearTimeout(_f);
                };
              }

              o.send((i = e == null ? void 0 : e.body) == null ? void 0 : i.toString());
            });

          case 12:
            return _context.abrupt("return", _context.sent);

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", {
              status: 0,
              body: (s = (n = _context.t0 == null ? void 0 : _context.t0.toString) == null ? void 0 : n.call(_context.t0)) != null ? s : "Unknown error"
            });

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 15]]);
  }));
}

var _h,
    A = (_h = /*#__PURE__*/function () {
  function h(e) {
    _classCallCheck(this, h);

    l(this, "apiURL");
    l(this, "dsn");
    l(this, "environment");
    l(this, "release");
    l(this, "sampleRate");
    l(this, "debug");
    l(this, "_scope");
    l(this, "shouldBuffer", !1);
    l(this, "bufferlimit", 20);
    l(this, "buffer", []);
    var r, n, s, a, u;
    this.environment = e.environment, this.release = e.release, this.sampleRate = (r = e.sampleRate) != null ? r : 1, this.debug = (n = e.debug) != null ? n : !1, this._scope = (s = e.scope) != null ? s : new Q(), this.apiURL = ue(e.dsn), this.dsn = e.dsn, this.shouldBuffer = (a = e.buffer) != null ? a : !1, this.bufferlimit = (u = e.bufferLimit) != null ? u : 20;
  }

  _createClass(h, [{
    key: "log",
    value: function log() {
      var _console;

      this.debug && (_console = console).log.apply(_console, arguments);
    }
  }, {
    key: "scope",
    get: function get() {
      return this._scope;
    }
  }, {
    key: "withScope",
    value: function withScope(e) {
      var r = this._scope.child();

      e(r);
    }
  }, {
    key: "captureException",
    value: function captureException(e, r) {
      this.captureEvent({
        type: "exception",
        level: "error",
        error: de(e),
        scope: r != null ? r : this._scope
      });
    }
  }, {
    key: "captureMessage",
    value: function captureMessage(e) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "info";
      var n = arguments.length > 2 ? arguments[2] : undefined;
      this.captureEvent({
        type: "message",
        level: r,
        message: e,
        scope: n != null ? n : this._scope
      });
    }
  }, {
    key: "captureEvent",
    value: function captureEvent(e) {
      if (Math.random() >= this.sampleRate) {
        this.log("Dropped event due to sample rate");
        return;
      }

      if (this.shouldBuffer) {
        if (this.buffer.length >= this.bufferlimit) return;
        this.buffer.push(e);
      } else this.sendEvent(e);
    }
  }, {
    key: "sendEvent",
    value: function sendEvent(e) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5e3;
      return x(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var n, s, a, u, o;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                this.log("Sending sentry event", e);
                n = le(e, this.environment, this.release);
                s = {
                  event_id: n.event_id,
                  dsn: this.dsn
                };
                a = {
                  type: "event"
                };
                u = JSON.stringify(s) + "\n" + JSON.stringify(a) + "\n" + JSON.stringify(n);
                _context2.next = 8;
                return pe(this.apiURL, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/x-sentry-envelope"
                  },
                  body: u
                }, r);

              case 8:
                o = _context2.sent;
                this.log("Sentry response", o.status), o.status !== 200 && (console.log(o.body), console.error("Failed to send event to Sentry", o));
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](0);
                console.error("Failed to send event", _context2.t0);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 12]]);
      }));
    }
  }, {
    key: "flush",
    value: function flush() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5e3;
      return x(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this = this;

        var r;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                this.log("Flushing sentry events", this.buffer.length);
                r = this.buffer.splice(0, this.buffer.length).map(function (n) {
                  return _this.sendEvent(n, e);
                });
                _context3.next = 5;
                return Promise.all(r);

              case 5:
                this.log("Flushed all events");
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);
                console.error("Failed to flush events", _context3.t0);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 8]]);
      }));
    }
  }], [{
    key: "init",
    value: function init(e) {
      _h._instance || (_h._instance = new _h(e));
    }
  }, {
    key: "instance",
    get: function get() {
      if (!_h._instance) throw new Error("Sentry has not been initialized");
      return _h._instance;
    }
  }, {
    key: "scope",
    get: function get() {
      return _h.instance.scope;
    }
  }, {
    key: "withScope",
    value: function withScope(e) {
      _h.instance.withScope(e);
    }
  }, {
    key: "captureException",
    value: function captureException(e, r) {
      _h.instance.captureException(e, r);
    }
  }, {
    key: "captureMessage",
    value: function captureMessage(e) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "info";
      var n = arguments.length > 2 ? arguments[2] : undefined;

      _h.instance.captureMessage(e, r, n);
    }
  }, {
    key: "flush",
    value: function flush() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5e3;
      return _h.instance.flush(e);
    }
  }, {
    key: "reset",
    value: function reset() {
      _h._instance = void 0;
    }
  }]);

  return h;
}(), l(_h, "_instance"), _h);

var he = "https://d233059272824702afc8c43834c4912d@sentry.hcaptcha.com/6",
    fe = "2.0.0",
    me = "production";

function j() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
  if (!t) return q();
  A.init({
    dsn: he,
    release: fe,
    environment: me
  });
  var e = A.scope;
  return F(e), q(e);
}

function q() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    addBreadcrumb: function addBreadcrumb(e) {
      t && t.addBreadcrumb(e);
    },
    captureRequest: function captureRequest(e) {
      t && t.setRequest(e);
    },
    captureException: function captureException(e) {
      t && A.captureException(e, t);
    }
  };
}

function H() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      t = _ref5.scriptLocation,
      e = _ref5.query,
      _ref5$loadAsync = _ref5.loadAsync,
      r = _ref5$loadAsync === void 0 ? !0 : _ref5$loadAsync,
      n = _ref5.crossOrigin,
      _ref5$apihost = _ref5.apihost,
      s = _ref5$apihost === void 0 ? "https://js.hcaptcha.com" : _ref5$apihost,
      _ref5$cleanup = _ref5.cleanup,
      a = _ref5$cleanup === void 0 ? !0 : _ref5$cleanup,
      _ref5$secureApi = _ref5.secureApi,
      u = _ref5$secureApi === void 0 ? !1 : _ref5$secureApi,
      _ref5$scriptSource = _ref5.scriptSource,
      o = _ref5$scriptSource === void 0 ? "" : _ref5$scriptSource;

  var c = arguments.length > 1 ? arguments[1] : undefined;
  var i = S(t),
      f = R(i);
  return new Promise(function (v, w) {
    var m = f.document.createElement("script");
    m.id = L, o ? m.src = "".concat(o, "?onload=").concat(b) : u ? m.src = "".concat(s, "/1/secure-api.js?onload=").concat(b) : m.src = "".concat(s, "/1/api.js?onload=").concat(b), m.crossOrigin = n, m.async = r;

    var T = function T(E, X) {
      try {
        !u && a && i.removeChild(m), X(E);
      } catch (G) {
        w(G);
      }
    };

    m.onload = function (E) {
      return T(E, v);
    }, m.onerror = function (E) {
      c && c(m.src), T(E, w);
    }, m.src += e !== "" ? "&".concat(e) : "", i.appendChild(m);
  });
}

var C = [];

function ge() {
  var _this2 = this;

  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    cleanup: !0
  };
  var e = arguments.length > 1 ? arguments[1] : undefined;

  try {
    e.addBreadcrumb({
      category: g,
      message: "hCaptcha loader params",
      data: t
    });
    var r = S(t.scriptLocation),
        n = R(r),
        s = C.find(function (_ref6) {
      var u = _ref6.scope;
      return u === n.window;
    });
    if (s) return e.addBreadcrumb({
      category: g,
      message: "hCaptcha already loaded"
    }), s.promise;
    var a = new Promise(function (u, o) {
      return x(_this2, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var c, i;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                n.window[b] = function () {
                  e.addBreadcrumb({
                    category: g,
                    message: "hCaptcha script called onload function"
                  }), u(n.window.hcaptcha);
                };

                c = U({
                  custom: t.custom,
                  render: t.render,
                  sentry: t.sentry,
                  assethost: t.assethost,
                  imghost: t.imghost,
                  reportapi: t.reportapi,
                  endpoint: t.endpoint,
                  host: t.host,
                  recaptchacompat: t.recaptchacompat,
                  hl: t.hl
                });
                _context4.next = 5;
                return H(d({
                  query: c
                }, t), function (i) {
                  e.captureRequest({
                    url: i,
                    method: "GET"
                  });
                });

              case 5:
                e.addBreadcrumb({
                  category: g,
                  message: "hCaptcha loaded",
                  data: s
                });
                _context4.next = 13;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);
                e.addBreadcrumb({
                  category: g,
                  message: "hCaptcha failed to load"
                });
                i = C.findIndex(function (f) {
                  return f.scope === n.window;
                });
                i !== -1 && C.splice(i, 1), o(new Error(_));

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 8]]);
      }));
    });
    return C.push({
      promise: a,
      scope: n.window
    }), a;
  } catch (r) {
    return e.captureException(r), Promise.reject(new Error(_));
  }
}

function $(t, e) {
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return x(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var n;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            n = r < 2 ? "Retry loading hCaptcha Api" : "Exceeded maximum retries";
            _context5.prev = 1;
            _context5.next = 4;
            return ge(t, e);

          case 4:
            return _context5.abrupt("return", _context5.sent);

          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](1);
            return _context5.abrupt("return", (e.addBreadcrumb({
              category: g,
              message: n
            }), r >= 2 ? (e.captureException(_context5.t0), Promise.reject(_context5.t0)) : (r += 1, $(t, e, r))));

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 7]]);
  }));
}

function xe() {
  return x(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var t,
        e,
        _args6 = arguments;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            t = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
            e = j(t.sentry);
            _context6.next = 4;
            return $(t, e);

          case 4:
            return _context6.abrupt("return", _context6.sent);

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
}

export { xe as hCaptchaLoader };